<div class="account-pages my-5 pt-sm-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-5">
                <div class="card overflow-hidden">
                    <div class="bg-soft bg-primary">
                        <div class="row">
                            <div class="col-7">
                                <div class="text-primary p-4">
                                    <h5 class="text-primary"> Cambio de Contraseña</h5>
                                    <p>MQB.</p>
                                </div>
                            </div>
                            <div class="col-5 align-self-end">
                                <img src="assets/images/profile-img.png" alt="" class="img-fluid">
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <div>
                            <a routerLink="/">
                                <div class="avatar-md profile-user-wid mb-4">
                                    <span class="avatar-title rounded-circle bg-light">
                                        <img src="assets/images/volumetricos.png" height="34" width="120">
                  </span>
                                </div>
                            </a>
                        </div>

                       <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="mt-4">

  <!-- ================= PASSWORD ================= -->
  <div class="mb-4">
    <label class="form-label fw-semibold">Nueva contraseña</label>

    <div class="input-group input-group-lg shadow-sm">
      <span class="input-group-text bg-light">
        <i class="mdi mdi-lock-outline text-primary"></i>
      </span>

      <input
        [type]="showPassword ? 'text' : 'password'"
        formControlName="password"
        class="form-control"
        placeholder="Ingresa tu nueva contraseña"
        [ngClass]="{'is-invalid': submitted && f.password.errors}"
        ngbTooltip="Mínimo 8 caracteres, mayúscula, minúscula, número y símbolo"
        placement="right"
      />

      <button class="btn btn-outline-secondary" type="button"
              (click)="togglePassword()">
        <i class="mdi" [ngClass]="showPassword ? 'mdi-eye-off' : 'mdi-eye'"></i>
      </button>
    </div>

    <!-- Fuerza de contraseña -->
    <div class="progress mt-2" style="height:6px">
      <div class="progress-bar"
           [class.bg-danger]="passwordStrength < 40"
           [class.bg-warning]="passwordStrength >= 40 && passwordStrength < 70"
           [class.bg-success]="passwordStrength >= 70"
           [style.width.%]="passwordStrength">
      </div>
    </div>

    <small class="text-muted">
      Seguridad: {{ strengthLabel }}
    </small>

    <div *ngIf="submitted && f.password.errors" class="invalid-feedback d-block mt-1">
      <div *ngIf="f.password.errors.required">La contraseña es obligatoria</div>
      <div *ngIf="f.password.errors.pattern">
        No cumple con los requisitos de seguridad
      </div>
    </div>
  </div>

  <!-- ================= CONFIRM PASSWORD ================= -->
  <div class="mb-4">
    <label class="form-label fw-semibold">Confirmar contraseña</label>

    <div class="input-group input-group-lg shadow-sm">
      <span class="input-group-text bg-light">
        <i class="mdi mdi-lock-check-outline text-primary"></i>
      </span>

      <input
        [type]="showPassword2 ? 'text' : 'password'"
        formControlName="password2"
        class="form-control"
        placeholder="Confirma tu contraseña"
        [ngClass]="{'is-invalid': submitted && f.password2.errors}"
      />

      <button class="btn btn-outline-secondary" type="button"
              (click)="togglePassword2()">
        <i class="mdi" [ngClass]="showPassword2 ? 'mdi-eye-off' : 'mdi-eye'"></i>
      </button>
    </div>

    <div *ngIf="submitted && f.password2.errors" class="invalid-feedback d-block">
      <div *ngIf="f.password2.errors.required">Confirmación requerida</div>
      <div *ngIf="f.password2.errors.confirmedValidator">
        Las contraseñas no coinciden
      </div>
    </div>
  </div>

  <!-- ================= BOTÓN ================= -->
  <button type="submit"
          class="btn btn-primary btn-lg w-100 shadow d-flex align-items-center justify-content-center gap-2">
    <i class="mdi mdi-shield-key-outline"></i>
    Cambiar contraseña
  </button>

</form>

                    </div>
                    <!-- end card-body-->
                </div>
                <!-- end card -->
                <div class="mt-5 text-center">
                    <!-- <p>Remember It ? <a type="button" routerLink="/account/login" class="fw-medium text-primary"> Sign In here</a> </p> -->
                    <img src="assets/images/volumetricos.png" height="50" width="120">
                    <p>© {{year}} eSCV. Desing by MBQ</p>
                </div>

            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </div>
    <!-- end container -->
</div>
<!-- end page -->